import { service } from '@ember/service';
import Modifier from 'ember-modifier';

export default class SetupRecaptcha extends Modifier {
  @service recaptcha;

  constructor(owner, args) {
    super(owner, args);
    this.recaptcha.initialize();
  }
}
